module.exports = __webpack_public_path__ + "img/left-arrow.2e34337b.svg";